module.exports = __webpack_public_path__ + "static/charlotte-55b49caf11c1903c484c8bf2f4eafb42.jpg";